import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=18fe229e&"
import script from "./Wallets.vue?vue&type=script&lang=ts&"
export * from "./Wallets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports